export default "__VITE_ASSET__69156ace__"